import React, { useEffect, useState } from 'react'
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { useNavigate } from 'react-router-dom';
import { useParams } from 'react-router-dom'
import { useSelector } from 'react-redux';
import axios from 'axios';
import LottiePlayer from "lottie-react";
import nodatafound from '../../../../../assets/animationicons/nodatafound.json'

const GroupAnalyticReport = ({ onSelect }) => {
    let params = useParams();
    const userData = useSelector((state) => state.userSlice);
    const configData = useSelector((state) => state.configSlice);
    let { groupId } = params;
    const [groups, setGroups] = useState([]);
    const fetchGroups = async () => {
        try {
            var { data } = await axios.get(`${configData.config.UNO_URL}/api/user/group/list/${groupId}`, {
                headers: {
                    'Authorization': `Bearer ${userData.token}`
                }
            });
            setGroups(data.data)
        } catch (error) {
            console.log(error)
        }
    }
    useEffect(() => {
        fetchGroups()
    }, [groupId])
    return (
        <>
            <div className="row px-2">
                {
                    groups.length > 0 ? groups.map((group, index) => (
                        <div className="col-sm-6 col-md-4 col-lg-3 col-xl-2 col-xxl-2 px-2">
                            <div className='groupcardesign' key={group.id}>
                                {group.avatar ? (
                                    <div className='avatarimg'>
                                        <img src={group.avatar} alt={`Avatar for ${group.name}`} title={group.name} />
                                    </div>
                                ) : (
                                    <div className='initials-placeholder'>
                                        {group?.name?.split(' ').map(word => word[0]).slice(0, 2).join('')}
                                    </div>
                                )}
                                <h6 className='groupname pb-1'>{group.name}</h6>
                                <div className="groupusercount pb-1">
                                    <p>{group.groups} Group  <span className='mx-1'>|</span></p>
                                    <p> {group.users} User  </p>
                                </div>
                                <button onClick={() => onSelect(group)} className='viewdetails'>Group Report <ArrowForwardIosIcon /></button>
                            </div>
                        </div>
                    ))
                        :
                        <>
                            <div className="text-center mt-5">
                                <LottiePlayer
                                    animationData={nodatafound}
                                    style={{ height: 200 }}
                                    autoplay
                                    loop
                                />
                                <h5>No Sub-Groups Found</h5>
                            </div>
                        </>
                }
            </div>
        </>
    )
}

export default GroupAnalyticReport
